module.exports = __webpack_public_path__ + "static/screenMockup-76c093a3f57696a88c10d9cac278b672.png";